import httpClient from 'shared/lib/httpClient';
import { parseDiseaseList } from '../schemas/MasterDataSchema';

/**
 * Fetch disease master-data list (ICD-10).
 *
 * @param {Object} params - query params (search, page, limit, sort, ...)
 * @param {AbortSignal} [signal] - cancellation signal from React Query
 * @returns {Promise<{ data: DiseaseItem[], meta: { http_status, last_page, ... } }>}
 */
export const getDiseaseList = async (params, signal) => {
  const response = await httpClient.get('/diseases', { params, signal });
  return parseDiseaseList(response?.data);
};
